import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validateLength } from 'ember-changeset-validations/validators';

let validation = {
  askAmount: validateLength({
    allowBlank: true,
    max: 50,
    message: "Can't be longer than 50 characters",
  }),
};

/*
  args
    - journalContactInfo
    - onSaved()
    - onCancel()
*/

export default class extends Component {
  @service fundsService;
  @service store;

  @tracked saving = false;
  @tracked showValidationErrors = false;
  @tracked saveError = null;

  get journalContact() {
    return this.args.journalContactInfo.journalContact;
  }

  get changeset() {
    if (this._changeset) {
      return this._changeset;
    }
    return (this._changeset = new Changeset(
      this.journalContact,
      lookupValidator(validation),
      validation,
    ));
  }

  get errorMessages() {
    let messages = [];
    this.changeset.get('errors')?.forEach((error) => {
      error.validation.forEach((message) => {
        messages.push(message);
      });
    });
    return messages;
  }

  @action
  async save() {
    if (this.saving) {
      return;
    }
    this.saving = true;
    this.showValidationErrors = false;
    await this.changeset.validate();
    if (this.changeset.get('isValid')) {
      try {
        await this.fundsService.confirmValidFundToken();
        await this.changeset.save();
        this.saving = false;
        this.args.onSaved();
      } catch (error) {
        this.saveError = error;
        this.saving = false;
      }
    } else {
      this.saving = false;
      this.showValidationErrors = true;
    }
  }
}
